import styled from 'styled-components';

const Spacer = styled.div<{ height: string }>`
  height: ${({ height }) => height || '20px'};
  width: 100%;
`;

export { Spacer };
